import get from 'lodash/get';

const hasDisplayValue = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim() !== '';
  return true;
};

const firstDisplayValue = (...values) => values.find(hasDisplayValue);

const stringifyObject = (value) => {
  try {
    return JSON.stringify(value);
  } catch (e) {
    return '';
  }
};

const normalizeList = (value) => {
  if (Array.isArray(value)) return value.flatMap(normalizeList);
  if (!hasDisplayValue(value)) return [];
  if (typeof value === 'object') {
    if (Object.keys(value).length === 0) return [];
    const stringifiedValue = stringifyObject(value);
    return stringifiedValue ? [stringifiedValue] : [];
  }

  const normalizedValue = `${value}`.trim();
  return normalizedValue ? [normalizedValue] : [];
};

export const joinUniqueValues = (...values) => [...new Set(values.flatMap(normalizeList))].join(', ');

const getCommandValue = (command) => {
  if (Array.isArray(command)) return command.map(getCommandValue);
  if (!hasDisplayValue(command) || typeof command !== 'object') return command;

  return firstDisplayValue(
    command.command,
    command.tool,
    command.name,
    command.command_id,
    command.id,
    command.value
  );
};

const getParameterValue = (command, allowRawObject = false) => {
  if (Array.isArray(command)) return command.map((item) => getParameterValue(item, allowRawObject));
  if (!hasDisplayValue(command) || typeof command !== 'object') return command;

  return firstDisplayValue(
    command.params,
    command.parameters,
    command.args,
    command.value,
    allowRawObject ? command : undefined
  );
};

export const getCommandData = (host = {}) => joinUniqueValues(
  getCommandValue(host.command),
  host.command_id,
  get(host, 'commands__id'),
  host.creator_command,
  host.creator_command_tool,
  host.creator_command_id,
  Array.isArray(host.commands) ? host.commands.map(getCommandValue) : [],
  Array.isArray(host.tools) ? host.tools.map(getCommandValue) : []
);

export const getParametersData = (host = {}) => joinUniqueValues(
  getParameterValue(host.params, true),
  getParameterValue(host.parameters, true),
  host.command_params,
  host.commands_params,
  host.creator_command_params,
  get(host, 'commands__params'),
  Array.isArray(host.commands) ? host.commands.map(getParameterValue) : [],
  Array.isArray(host.tools) ? host.tools.map(getParameterValue) : []
);

export const getMacData = (host = {}) => host.mac || host.mac_address || get(host, 'metadata.mac', '');
